import CheckInEventForm from '../../components/CheckInEventForm'
import StampCampaignRanking from './components/StampCampaignRanking'
import StampRewardPerformance from './components/StampRewardPerformance'
import StampUserDistribution from './components/StampUserDIstribution'

function CheckInStampAnalysis() {
  return (
    <>
      <CheckInEventForm />
      <div className='grow grid xl:grid-cols-2 grid-cols-1 gap-4'>
        <StampRewardPerformance />
        <StampUserDistribution />
        <StampCampaignRanking className='col-span-2' />
      </div>
    </>
  )
}

export default CheckInStampAnalysis
